import Layout from "@/layout";

export default {
  path: "/onboarding",
  component: Layout,
  redirect: "/onboarding/index",
  children: [
    {
      path: "index",
      name: "onboarding",
      meta: {
        title: "Onboarding",
        icon: "onboarding-v2",
        tag: 'ic-ongoing-tag',
        tagWidth: '52px',
        tagHeight: '12px'
      },
      hidden: true,
    },
  ],
};
